import React, { useState } from "react";
import { GlobalTableActionButton } from "../../../../global/GlobalTableActionButton";
import { getCsrfToken } from "../../../../public/api/authApi";
import { downloadMyTournamentCertificate } from "../../api/studentTournamentApi";

export default function MyTournamentsCertificateButton({ row, onFeedback }) {
  const [loading, setLoading] = useState(false);

  const unavailableMessage =
    row?.certificate_unavailable_message || "No certificate available";

  const handleClick = async () => {
    if (!row?.certificate_downloadable) {
      onFeedback?.({
        type: "notice",
        title: "Certificate unavailable",
        text: unavailableMessage,
      });
      return;
    }

    setLoading(true);
    try {
      let csrf = localStorage.getItem("csrf-token");
      if (!csrf) {
        csrf = await getCsrfToken();
        localStorage.setItem("csrf-token", csrf);
      }

      const { filename } = await downloadMyTournamentCertificate(
        row.tournament_db_id,
        csrf
      );
      onFeedback?.({
        type: "success",
        text: filename
          ? `Certificate downloaded (${filename}).`
          : "Certificate downloaded.",
      });
    } catch (err) {
      onFeedback?.({
        type: "notice",
        title: "Unable to download",
        text: err?.message || "Certificate download could not be completed.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <GlobalTableActionButton
      action="certificate"
      variant="ghost"
      loading={loading}
      onClick={handleClick}
      title={
        row?.certificate_downloadable
          ? "Download tournament certificate"
          : unavailableMessage
      }
    />
  );
}
